<template>
  <div
    style="width: 240px; text-align: right"
    class="pt-4"
  >
    <iframe
      src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fcostasolrent%2F&width=150&layout=button_count&action=like&size=small&share=true&height=46&appId=1834807159883614"
      width="150"
      height="20"
      style="border: none; overflow: hidden"
      scrolling="no"
      frameborder="0"
      allowfullscreen="true"
      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
    />
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'FacebookFrame',
}
</script>
